// extracted by mini-css-extract-plugin
export default {"twoColumnInput":"TwoColumnInput_twoColumnInput__NBtbO"};